import { Stack, Typography } from '@mui/material';
import { LinkArrowLeft2 } from 'Components';
import { LinkArrowLeft } from 'Components/LinkArrowLeft';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';

interface IGeneralInfo {
  districtName: string;
  districtId: number;
  urlName: string;
}

export enum districtType {
  DAN = 7,
}

export const GeneralInfo = ({
  districtName,
  districtId,
  urlName,
}: IGeneralInfo) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.PersonalTeam);
  const isDesktop = useIsDesktop();

  return (
    <Stack gap={'24px'}>
      <Stack gap={'4px'}>
        <Typography variant={'body1'} component='h2'>
          {dictionary.generalInfo1}
        </Typography>
        <Stack>
          {isDesktop && (
            <>
              <Typography variant={'body3'}>
                {dictionary.generalInfo2}
              </Typography>
              <Typography variant={'body3'}>
                {dictionary.generalInfo3}
              </Typography>
            </>
          )}
          {!isDesktop && (
            <Typography variant={'body3'} width={'300px'}>
              {dictionary.generalInfo2} {dictionary.generalInfo3}
            </Typography>
          )}
        </Stack>
      </Stack>
      <Stack gap={'12px'}>
        <LinkArrowLeft2
          text={dictionary.links.generalTLVDistrict + (districtName || '')}
          href={
            districtId === districtType.DAN
              ? 'https://shikum.mod.gov.il/ContactUs/dan'
              : `https://shikum.mod.gov.il/ContactUs/${urlName}`
          }
          newWindow={true}
        />
        <LinkArrowLeft2
          text={dictionary.links.generalDistricts}
          href={'https://shikum.mod.gov.il/ContactUs'}
          newWindow={true}
        />
      </Stack>
    </Stack>
  );
};
